import { InfoCircleFilled } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import styles from 'styles/components/remainingAvailableRequests.module.scss';

const RemainingAvailableRequests = ({ pendingGiveRequestsCount = 0 }) => {
  return (
    <Tag className={styles.tag} color="volcano">
      <Tooltip
        title={
          pendingGiveRequestsCount >= 2
            ? 'You can only have 2 active give requests at a time'
            : 'You still have Give requests available, browse and click Give on Domains'
        }
      >
        Active Give requests {pendingGiveRequestsCount}/2 <InfoCircleFilled />
      </Tooltip>
    </Tag>
  );
};

export default RemainingAvailableRequests;
